import axiosInstance from '../axios/axiosInstance';
import { BookAppendixItemType } from '../model/enum';

export const addBookAppendixItem = async (bookAppendixId: string, itemId: string, type: BookAppendixItemType) => {
  return await axiosInstance.post('/book-appendix-items', {
    bookAppendixId,
    itemId,
    type,
  });
};

export const deleteBookAppendixItem = async (id: string) => {
  return await axiosInstance.delete(`/book-appendix-items/${id}`);
};

export const pushBookAppendixItemUp = async (id: string) => {
  return await axiosInstance.put(`/book-appendix-items/push-up/${id}`);
};

export const pushBookAppendixItemDown = async (id: string) => {
  return await axiosInstance.put(`/book-appendix-items/push-down/${id}`);
};
